import { render, staticRenderFns } from "./consulting_list.vue?vue&type=template&id=1e215d82&scoped=true&"
import script from "./consulting_list.vue?vue&type=script&lang=ts&"
export * from "./consulting_list.vue?vue&type=script&lang=ts&"
import style0 from "./consulting_list.vue?vue&type=style&index=0&id=1e215d82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e215d82",
  null
  
)

export default component.exports